import React, { createContext, useRef } from "react";
import axios from "axios";

const FetchContext = createContext();
const { Provider } = FetchContext;

const getCsrfCookie = () => {
  const match = document.cookie.match(/(^|;\s*)XSRF-TOKEN=([^;]+)/);
  return match ? decodeURIComponent(match[2]) : null;
};

const addCsrfInterceptor = (instance) => {
  instance.interceptors.request.use((config) => {
    const token = getCsrfCookie();
    if (token) config.headers["X-CSRF-Token"] = token;
    return config;
  });
};

const FetchProvider = ({ children }) => {
  const publicAxiosRef = useRef(axios.create({ baseURL: process.env.REACT_APP_API_URL }));
  const authAxiosRef = useRef(axios.create({ baseURL: process.env.REACT_APP_API_URL }));

  const publicAxios = publicAxiosRef.current;
  const authAxios = authAxiosRef.current;

  addCsrfInterceptor(publicAxios);
  addCsrfInterceptor(authAxios);

  authAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      const code = error && error.response ? error.response.status : 0;
      if (code === 401 || code === 403) {
      }
      return Promise.reject(error);
    }
  );

  return (
    <Provider
      value={{
        authAxios,
        publicAxios,
      }}
    >
      {children}
    </Provider>
  );
};

export { FetchContext, FetchProvider };
